import { Component, OnInit } from '@angular/core';
import { ABCisTableModel, ColumnType } from 'src/app/components/abcis-table/abcis-table.component';
import { ApiService, ABCisApi } from 'src/app/handlers/apiHandler.service';

@Component({
  selector: 'app-invoice-rule-map-config',
  standalone: false,
  templateUrl: './invoice-rule-map-config.component.html',
  styleUrls: ['./invoice-rule-map-config.component.scss']
})
export class InvoiceRuleMapConfigComponent implements OnInit {
  tableConfig: ABCisTableModel;

  constructor(private apiHandler: ApiService) { }

  ngOnInit() {
    this.SetTableConfig();
  }

  SetTableConfig() {
    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: 'invoice-rule-map',
        approxamateRowCount: 1000,
        anyParams: true
      },
      colConfig: [
        { field: 'invoicerulemapid', header: 'Invoice Rule Map ID', type: ColumnType.String, isReadonly: true, isPrimary: true, notInForm: true  },
        { field: 'invoiceruleid', header: 'Invoice Rule', type: ColumnType.MultiSelectComplex, setUrl: 'invoice-rule/lookup' },
        { field: 'retailgroupid', header: 'Retail Group', type: ColumnType.MultiSelectComplex, setUrl: 'retail-group/lookup' },
        { field: 'storeid', header: 'Store', type: ColumnType.MultiSelectComplex, setUrl: 'store/lookup' },
        { field: 'globalsupplierid', header: 'Global Supplier', type: ColumnType.MultiSelectComplex, setUrl: 'global-supplier/lookup' }
      ],
      addFormConfig: {
        header: 'Invoice Rule Maps'
      },
      isConfigurable: true
    };
  }
}
